import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetTokensMultiplierRatioDataTypes } from "../../../../Schema/getTokensMultiplierRatio.types";
import { call } from "@redux-saga/core/effects";
import { queryClient } from "../../../store";

export type GetTokensMultiplierRatioLoadAction = {
  type: string;
  payload: {};
};

export type GetTokensMultiplierRatioData = {
  data: GetTokensMultiplierRatioDataTypes;
};

const GetTokensMultiplierRatio = new ReduxFetchState<GetTokensMultiplierRatioData, {}, any>(
  "getTokensMultiplierRatio",
);

export function* watchGetTokensMultiplierRatio(action: GetTokensMultiplierRatioLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetTokensMultiplierRatioData = yield call([queryClient, queryClient.fetchQuery], {
      queryKey: ["getTokensMultiplierRatio", lang],
      queryFn: async () => {
        const res = await axios({
          url: "/api/v1/ai/tokens-multiplier-ratio",
          method: "GET",
          headers: { lang },
        });
        return { data: res.data };
      },
      staleTime: 1440 * 60 * 1000,
    });

    yield put(GetTokensMultiplierRatio.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    console.log(e, "error is here");
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetTokensMultiplierRatio.actions.loadFailure(e.message));
  }
}

export function* getTokensMultiplierRatioSagas() {
  yield takeEvery(GetTokensMultiplierRatio.actionTypes.load, watchGetTokensMultiplierRatio);
}

export function useGetTokensMultiplierRatio() {
  const { loading, data, ...getTokensMultiplierRatioState } = useAppSelector(
    (state) => state.getTokensMultiplierRatio,
  );
  const dispatch = useAppDispatch();

  const dispatchGetTokensMultiplierRatio = useCallback(() => {
    dispatch(GetTokensMultiplierRatio.actions.load());
  }, [dispatch]);

  return {
    ...getTokensMultiplierRatioState,
    dispatchGetTokensMultiplierRatio,
    getTokensMultiplierRatioLoading: loading,
    getTokensMultiplierRatioData: data,
  };
}

export const {
  actionTypes: getTokensMultiplierRatioActionsTypes,
  actions: getTokensMultiplierRatioActions,
  reducer: getTokensMultiplierRatioReducer,
} = GetTokensMultiplierRatio;
